<div class="loading-container" role="status">
  <div class="loading-content" aria-hidden="true">
    <i class="fa-light fa-loader loading-spinner"></i>
    <p class="loading-text">Just a moment...</p>
  </div>
</div>
